import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gradient-to-br from-amber-400 via-yellow-400 to-amber-500 text-amber-900">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 py-10 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-8 mb-8 md:mb-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="bg-white/30 rounded-2xl p-4 mb-4">
              <div className="flex items-center gap-2 mb-3">
                <img
                  src="https://public.readdy.ai/ai/img_res/f704ac6a-a45e-41ab-b34d-a4b4313691a9.png"
                  alt="皇冠鸿运商城"
                  className="w-9 h-9 md:w-10 md:h-10 object-contain"
                />
                <span className="text-amber-900 font-bold text-base md:text-lg" style={{ fontFamily: "'Noto Serif SC', serif" }}>皇冠鸿运商城</span>
              </div>
              <p className="text-amber-800/80 text-xs leading-relaxed">
                皇冠鸿运商城 — 中国领先的综合电商平台，正品保障，极速配送，全球购物一站搞定。
              </p>
            </div>
            <div className="flex items-center gap-2.5">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-tiktok-line", label: "抖音" },
                { icon: "ri-youtube-line", label: "YouTube" },
              ].map((s) => (
                <button key={s.label} title={s.label} className="w-8 h-8 flex items-center justify-center bg-white/40 hover:bg-white/70 text-amber-900 rounded-full cursor-pointer transition-all">
                  <i className={`${s.icon} text-sm`}></i>
                </button>
              ))}
            </div>
          </div>

          {/* Links */}
          {[
            { title: "购物指南", links: ["新手上路", "购物流程", "会员介绍", "生活旅行", "常见问题"] },
            { title: "配送服务", links: ["配送范围", "配送时间", "配送费用", "自提服务", "海外配送"] },
            { title: "售后服务", links: ["退换货政策", "价格保护", "正品保障", "客服中心", "投诉建议"] },
            { title: "商家合作", links: ["入驻申请", "网红合作", "分销招募", "广告投放", "联系我们"] },
          ].map((col) => (
            <div key={col.title}>
              <h4 className="text-amber-900 font-bold text-sm mb-3 md:mb-4">{col.title}</h4>
              <ul className="space-y-1.5 md:space-y-2">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#" className="text-amber-800 text-xs hover:text-amber-900 hover:font-semibold transition-colors cursor-pointer">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Crowntalk promo strip */}
        <div className="bg-white/30 rounded-xl p-4 md:p-5 flex flex-col sm:flex-row items-center justify-between gap-4 mb-6 md:mb-8">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-red-500 rounded-xl flex-shrink-0">
              <i className="ri-message-3-line text-white text-base md:text-lg"></i>
            </div>
            <div>
              <p className="text-amber-900 font-semibold text-sm">下载 Crowntalk，与全球好友畅聊</p>
              <p className="text-amber-800 text-xs">支持 iOS · Android · 全球 180+ 国家可用 · <a href="/crowntalk" className="underline hover:text-amber-900">了解更多</a></p>
            </div>
          </div>
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <button
              onClick={() => navigate("/crowntalk")}
              className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 bg-white/50 hover:bg-white/80 text-amber-900 px-4 py-2 rounded-lg text-xs font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-apple-line"></i> App Store
            </button>
            <button
              onClick={() => navigate("/crowntalk")}
              className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg text-xs font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-android-line"></i> Google Play
            </button>
          </div>
        </div>

        {/* ICP & License Bar */}
        <div className="border-t border-amber-500/50 pt-4 md:pt-5 mb-4">
          <div className="flex justify-center mb-3 md:mb-4">
            <a
              href="https://www.crownhongyunmall.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-white/30 hover:bg-white/50 text-amber-900 px-4 md:px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer"
            >
              <i className="ri-global-line text-amber-700"></i>
              www.crownhongyunmall.com
              <i className="ri-external-link-line text-amber-600 text-xs"></i>
            </a>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 md:gap-6 flex-wrap">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-1.5 text-amber-800 text-xs hover:text-amber-900 transition-colors cursor-pointer"
            >
              <i className="ri-government-line text-amber-700"></i>
              <span>粤ICP备2026XXXXXX号</span>
            </a>
            <span className="hidden sm:block text-amber-600">|</span>
            <a
              href="https://www.beian.gov.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-1.5 text-amber-800 text-xs hover:text-amber-900 transition-colors cursor-pointer"
            >
              <i className="ri-shield-star-line text-amber-700"></i>
              <span>粤公网安备 44010602XXXXXX号</span>
            </a>
            <span className="hidden sm:block text-amber-600">|</span>
            <span className="flex items-center gap-1.5 text-amber-800 text-xs">
              <i className="ri-store-2-line text-amber-700"></i>
              <span>增值电信业务经营许可证：粤B2-2026XXXX</span>
            </span>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-amber-500/50 pt-4 md:pt-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-amber-800 text-xs text-center sm:text-left">
            © 2026 皇冠鸿运商城 Crown HongYun Mall. 保留所有权利。
          </p>
          <div className="flex items-center gap-3 md:gap-4 flex-wrap justify-center">
            {[
              { label: "隐私政策", href: "/privacy" },
              { label: "用户协议", href: "/terms" },
              { label: "Cookie 设置", href: "#" },
              { label: "网站地图", href: "/sitemap.xml" },
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-amber-800 text-xs hover:text-amber-900 hover:font-semibold transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
